import React from 'react'
import type { FC } from 'react'

import { useTheme } from '../../../core/theme/theme'

export const IconOffline: FC = () => {
  const { theme } = useTheme()

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        fill={theme.fg.NEED_FOUNDATION_REVIEW_dark.primary}
        d="M8.147 9.146a.5.5 0 01.707 0l1.138 1.138 1.137-1.138a.5.5 0 01.708.707l-1.138 1.138 1.138 1.138a.5.5 0 11-.707.707l-1.138-1.138-1.138 1.138a.5.5 0 11-.708-.707l1.139-1.138-1.138-1.138a.5.5 0 010-.707z"
      />
      <path
        fill={theme.fg.NEED_FOUNDATION_REVIEW_dark.primary}
        fillRule="evenodd"
        d="M5.27 8.065a4.974 4.974 0 014.823-3.785 4.977 4.977 0 014.973 4.973v.25A3.115 3.115 0 0118 12.609a3.114 3.114 0 01-3.11 3.11H5.856A3.855 3.855 0 012 11.862a3.844 3.844 0 013.27-3.798zm6.712 6.652H5.855A2.855 2.855 0 013 11.863C3 10.338 4.2 9.1 5.71 9.024a.5.5 0 00.468-.418 3.974 3.974 0 013.915-3.326 3.977 3.977 0 013.973 3.973V10a.5.5 0 00.5.5h.325c1.16 0 2.109.948 2.109 2.11 0 1.16-.948 2.108-2.11 2.108h-2.908z"
        clipRule="evenodd"
      />
    </svg>
  )
}
